var _path, _circle, _g, _g2, _g3, _g4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "movie",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M13.248,45.5c-.275-.157-1.171.907-1.441.739a25,25,0,1,1,31.711-4.444c-1.043,1.149-4.4,0-5.635.935Z",
    fill: "#3c3c99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 20.109,
    cy: 20.109,
    r: 20.109,
    transform: "translate(4.891 2.6)",
    fill: "#5e5ebc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(10.353 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M154.062,355.391l-1.247-.726c-3.454,1.979-6.178,4.7-10.413,4.828q-.372.011-.747.011a25.045,25.045,0,0,1-6.178-.769c-2.2-.558-3.417-2.268-5.337-3.364l-.86.02a12.391,12.391,0,0,1,24.782,0Z",
    transform: "translate(-127.008 -309.504)",
    fill: "#98e565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M144.374,343.3a12.4,12.4,0,0,0-9.689,12.095v3.128a24.874,24.874,0,0,1-5.4-2.288v-.84A12.4,12.4,0,0,1,144.374,343.3Z",
    transform: "translate(-127.008 -309.504)",
    fill: "#81cc50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M135.29,14.639V29.53a3.952,3.952,0,0,1-3.952,3.953h-21.5a3.82,3.82,0,0,1-3.82-3.82V14.8A14.651,14.651,0,0,1,123.8.339h0c.29.063.576.135.859.215A14.646,14.646,0,0,1,135.29,14.639Z",
    transform: "translate(-106.013 0)",
    fill: "#ffd939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M123.8.34A14.815,14.815,0,0,0,112.28,14.816V33.483h-2.448a3.82,3.82,0,0,1-3.82-3.82V14.8A14.651,14.651,0,0,1,123.795.339h0Z",
    transform: "translate(-106.012 0)",
    fill: "#ffc23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M223.725,292.4v7.083a3.952,3.952,0,1,1-7.9,0V292.4Z",
    transform: "translate(-205.098 -263.847)",
    fill: "#ce6a52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M218.267,321.732v6.161a3.954,3.954,0,0,1-2.439-3.652v-4.4Z",
    transform: "translate(-205.104 -288.604)",
    fill: "#c1593d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M130.475,191.453h-18.53a5.354,5.354,0,0,1-5.354-5.354,3.348,3.348,0,0,1,3.348-3.348h22.542a3.348,3.348,0,0,1,3.348,3.348A5.354,5.354,0,0,1,130.475,191.453Z",
    transform: "translate(-106.534 -164.904)",
    fill: "#c1593d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M128.623,206.325a3.553,3.553,0,0,1-3.549-3.549,1.545,1.545,0,0,1,1.543-1.543h22.542a1.545,1.545,0,0,1,1.543,1.543,3.553,3.553,0,0,1-3.549,3.549Z",
    transform: "translate(-123.212 -181.581)",
    fill: "#b24d36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M170.754,116.9v7.634a10.38,10.38,0,1,1-20.761,0V116.9c0-.244.008-.487.026-.727a8.789,8.789,0,0,0,4.52,1.243h.068a8.828,8.828,0,0,0,8.172-5.658,5.921,5.921,0,0,0,7.746,2.973A10.347,10.347,0,0,1,170.754,116.9Z",
    transform: "translate(-145.698 -100.839)",
    fill: "#ce6a52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M219.51,260.921a3.594,3.594,0,0,0,7.183,0",
    transform: "translate(-208.426 -235.44)",
    fill: "#fcf8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M163.056,175.368a10.386,10.386,0,0,1-13.063-10.03V157.7c0-.244.008-.487.026-.727a8.789,8.789,0,0,0,4.52,1.243h.068c.253,0,.5-.014.749-.037v7.157A10.383,10.383,0,0,0,163.056,175.368Z",
    transform: "translate(-145.698 -141.646)",
    fill: "#c1593d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M247.424,135.519v9.935a1.076,1.076,0,0,1-2.152,0v-7.99A8.843,8.843,0,0,0,247.424,135.519Z",
    transform: "translate(-231.672 -122.285)",
    fill: "#c1593d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(1.215 15.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M145.3,158.956l-.831,5.454a1.155,1.155,0,0,1-1.142.981H134.8a1.166,1.166,0,0,1-1.1-.779l-1.025-2.909a.839.839,0,0,0-1.583,0l-1.025,2.909a1.166,1.166,0,0,1-1.1.779h-8.529a1.155,1.155,0,0,1-1.142-.981l-.831-5.454a1.155,1.155,0,0,1,1.142-1.329h24.554A1.155,1.155,0,0,1,145.3,158.956Z",
    transform: "translate(-118.452 -157.627)",
    fill: "#fcf8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M121.666,165.387h-1.225a1.155,1.155,0,0,1-1.142-.981l-.831-5.454a1.156,1.156,0,0,1,1.142-1.329h1.225a1.156,1.156,0,0,0-1.142,1.329l.831,5.454A1.155,1.155,0,0,0,121.666,165.387Z",
    transform: "translate(-118.455 -157.623)",
    fill: "#eae6e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M140.881,178.155v-2.2a1.1,1.1,0,0,1,1.1-1.1h6.858a1.1,1.1,0,0,1,1.037,1.464l-.776,2.2a1.1,1.1,0,0,1-1.037.734H141.98A1.1,1.1,0,0,1,140.881,178.155Z",
    transform: "translate(-138.691 -173.172)",
    fill: "#5cb5f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M287.428,178.155v-2.2a1.1,1.1,0,0,0-1.1-1.1H279.47a1.1,1.1,0,0,0-1.037,1.464l.776,2.2a1.1,1.1,0,0,0,1.037.734h6.083A1.1,1.1,0,0,0,287.428,178.155Z",
    transform: "translate(-262.753 -173.172)",
    fill: "#ff645c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M143.2,179.253H141.98a1.1,1.1,0,0,1-1.1-1.1v-2.2a1.1,1.1,0,0,1,1.1-1.1H143.2a1.1,1.1,0,0,0-1.1,1.1v2.2A1.1,1.1,0,0,0,143.2,179.253Z",
    transform: "translate(-138.691 -173.171)",
    fill: "#4ba9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M281.467,179.253h-1.225a1.1,1.1,0,0,1-1.037-.734l-.775-2.2a1.1,1.1,0,0,1,1.037-1.465h1.224a1.1,1.1,0,0,0-1.037,1.465l.776,2.2A1.1,1.1,0,0,0,281.467,179.253Z",
    transform: "translate(-262.75 -173.171)",
    fill: "#ff4c48"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(24.44 35.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M280.207,373.3a2.1,2.1,0,1,0,0-4.208,2.127,2.127,0,0,0-.264.017,1.338,1.338,0,0,0-1.886-1.487,2.1,2.1,0,0,0-2.95-1.465,1.338,1.338,0,0,0-2.423,0,2.1,2.1,0,0,0-2.95,1.465,1.338,1.338,0,0,0-1.886,1.487,2.127,2.127,0,0,0-.264-.017,2.1,2.1,0,1,0,0,4.208",
    transform: "translate(-263.995 -365.385)",
    fill: "#ffd939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M271.79,371.235a2.121,2.121,0,0,1,.7.118,2.1,2.1,0,0,0-1.034,2.281,1.338,1.338,0,0,0-1.251,1.887,1.321,1.321,0,0,0,.142.243,2.2,2.2,0,0,0-.248.093,2.1,2.1,0,0,0-1.082,2.718h-1.433a2.1,2.1,0,1,1,0-4.208,2.057,2.057,0,0,1,.265.017,1.339,1.339,0,0,1,1.886-1.487A2.1,2.1,0,0,1,271.79,371.235Z",
    transform: "translate(-263.993 -370.664)",
    fill: "#ffc23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M337.447,371.144a2.1,2.1,0,0,0-.2-.08c.051-.029.1-.055.159-.08s.116-.049.174-.07A1.354,1.354,0,0,0,337.447,371.144Z",
    transform: "translate(-328.758 -370.374)",
    fill: "#ffc23b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M269.348,423.81a25.144,25.144,0,0,1-3.43,3.14c-.853.646-1.5-.308-2.438.226-.409.234-1.068,2-1.491,2.215a24.851,24.851,0,0,1-3.579,1.454c-.575.183-1.158-1.018-1.75-.877-.523.125-1.053,1.6-1.588,1.688a25.051,25.051,0,0,1-3.5.347l-1.271-6.286h0a2.008,2.008,0,0,1-.037-.378,1.98,1.98,0,1,1,3.961,0c0-1.094.886.132,1.98.132.547,0,.306-1.067.664-.709s1.316.03,1.316.577a1.98,1.98,0,1,1,3.96,0c0-1.094,1.047.031,2.14.031.547,0,.277-1.1.636-.738s1.185.16,1.185.707a1.98,1.98,0,0,1,3.237-1.53Z",
    transform: "translate(-250.27 -417.698)",
    fill: "#fcf8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M253.806,431.84q-1.1.13-2.229.164l-1.271-6.286h0a2.009,2.009,0,0,1-.037-.378,1.981,1.981,0,0,1,3.112-1.626,1.979,1.979,0,0,0-.85,1.626,2.007,2.007,0,0,0,.037.378h0Z",
    transform: "translate(-250.27 -417.698)",
    fill: "#eae6e1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(3.961 5.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M295.01,430.846a24.9,24.9,0,0,1-3.422.825l-.758-6.331a1.98,1.98,0,1,1,3.96,0Z",
    transform: "translate(-290.83 -423.36)",
    fill: "#ff645c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M374.4,425.34l-.192,1.61a24.924,24.924,0,0,1-2.682,1.773q-.612.352-1.247.668l.161-4.052a1.98,1.98,0,1,1,3.96,0Z",
    transform: "translate(-362.521 -423.36)",
    fill: "#ff645c"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(5.506 35.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M120.968,428.91c-.267-.067-.53-.14-.793-.216a24.874,24.874,0,0,1-5.4-2.288q-.413-.236-.817-.488l-.753-3.966,6.222-1.182Z",
    transform: "translate(-107.651 -415.045)",
    fill: "#ce6a52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M116.6,434.247q-.939-.437-1.832-.947-.413-.236-.817-.488l-.753-3.966,2.294-.436Z",
    transform: "translate(-107.651 -421.939)",
    fill: "#c1593d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M74.658,391.025a1.008,1.008,0,0,1-.635-.217l-3.763-2.963a1.012,1.012,0,1,1,1.253-1.591l3.763,2.963a1.012,1.012,0,0,1-.617,1.808Z",
    transform: "translate(-68.556 -383.704)",
    fill: "#c1593d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M64.726,410.259l-7.541-1.585a1.012,1.012,0,1,1,.417-1.981l7.541,1.585a1.012,1.012,0,0,1-.417,1.981Z",
    transform: "translate(-56.381 -402.323)",
    fill: "#ce6a52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M112.393,370.084a4.011,4.011,0,1,1,1.65-7.85,1.012,1.012,0,0,1-.417,1.981,1.986,1.986,0,1,0-.817,3.887l.782,1.2Z",
    transform: "translate(-104.048 -362.148)",
    fill: "#ce6a52"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(14.146 34.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.919,
    cy: 1.919,
    r: 1.919,
    transform: "translate(0 0.001)",
    fill: "#ffd939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M147.473,357.863a1.9,1.9,0,0,1-.7.133,1.919,1.919,0,1,1,.7-3.707,1.919,1.919,0,0,0,0,3.574Z",
    transform: "translate(-144.853 -354.157)",
    fill: "#ffc23b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M142.25,384.612a1.986,1.986,0,0,0,2.226-2.746,1.012,1.012,0,0,1,1.851-.82,4.011,4.011,0,0,1-4.493,5.547Z",
    transform: "translate(-127.982 -343.291)",
    fill: "#ce6a52"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.1805a4bd11564e82528c67e85392e054.svg";
export { ForwardRef as ReactComponent };